import {
  IAdvancedRichText,
  IBaseLayoutOptions,
  IInputWidget,
  WidgetType,
} from '@framework/engine';

export enum UploadWidgetKind {
  Button = 'button',
  DragArea = 'dragarea',
}
export enum UploadButtonsLayout {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}
export interface IUploadWidgetLayout extends IBaseLayoutOptions {
  /** Nascondi etichetta */
  hideLabel?: boolean;
  /** Layout dei pulsanti se visualizzati doppi per omissis */
  buttonLayout?: UploadButtonsLayout;
}

export const WidgetUploadType = 'upload' as WidgetType.Upload;

/**
 * Input Upload
 */
export interface IUploadWidget extends IInputWidget {
  type: WidgetType.Upload;
  kind: UploadWidgetKind;
  /** Titolo pulsante o DragArea */
  title?: IAdvancedRichText;
  /** Nome del file (sovrascritto) */
  internalFileName?: string | null;
  /** Descrizione del file (verso Protocollo) */
  internalDescription?: string | null;
  /** Titolo pulsante/DragArea versione pubblica */
  publicUploadTitle?: IAdvancedRichText;
  /** Help text per l'area di upload della versione pubblica */
  publicHelpText?: IAdvancedRichText;
  /** Label del campo di input della versone pubblica */
  publicUploadLabel?: IAdvancedRichText;

  layout?: IUploadWidgetLayout;

  aiCheckDocumentType?: boolean | null;
  aiAllowedDocumentTypes?: string[] | null;

  /**  Indica se il valore è di tipo immagine */
  isImage?: boolean | null;
}
